{
  "title": "Patients",
  "description": "Manage your patients and their information",
  "addPatient": "Add Patient",
  "search": {
    "placeholder": "Search patients...",
    "noResults": "No patients found",
    "tryDifferent": "Try a different search term"
  },
  "empty": {
    "title": "No patients yet",
    "description": "Start by adding your first patient to begin managing their care",
    "addFirst": "Add First Patient"
  },
  "list": {
    "title": "Your Patients",
    "description": "You have {{count}} patient(s) in total"
  },
  "table": {
    "patient": "Patient",
    "email": "Email",
    "phone": "Phone",
    "createdAt": "Added",
    "actions": "Actions",
    "view": "View",
    "gender": {
      "man": "Male",
      "woman": "Female",
      "other": "Other"
    }
  },
  "create": {
    "title": "Add New Patient",
    "description": "Enter the patient's information to add them to your practice",
    "fields": {
      "firstName": "First Name",
      "lastName": "Last Name",
      "email": "Email",
      "phone": "Phone",
      "birthDate": "Birth Date",
      "selectBirthDate": "Select birth date",
      "gender": "Gender",
      "selectGender": "Select gender",
      "genderOptions": {
        "man": "Male",
        "woman": "Female",
        "other": "Other"
      }
    },
    "cancel": "Cancel",
    "create": "Add Patient",
    "creating": "Adding..."
  },
  "edit": {
    "title": "Edit Patient",
    "description": "Update {{name}}'s information",
    "fields": {
      "firstName": "First Name",
      "lastName": "Last Name",
      "email": "Email",
      "phone": "Phone",
      "birthDate": "Birth Date",
      "gender": "Gender",
      "selectGender": "Select gender",
      "genderOptions": {
        "man": "Male",
        "woman": "Female",
        "other": "Other"
      }
    },
    "cancel": "Cancel",
    "update": "Update Patient",
    "updating": "Updating..."
  },
  "details": {
    "title": "Patient Details",
    "description": "View and manage patient information",
    "back": "Back to Patients",
    "edit": "Edit Patient",
    "notFound": "Patient not found",
    "notFoundDescription": "The patient you're looking for doesn't exist or has been removed",
    "backToPatients": "Back to Patients",
    "patientInfo": "Patient Information",
    "patientData": "Patient Data",
    "patientDataDescription": "View evaluations, notes, and other patient data",
    "yearsOld": "years old",
    "createdOn": "Patient since",
    "gender": {
      "man": "Male",
      "woman": "Female",
      "other": "Other"
    },
    "tabs": {
      "overview": "Overview",
      "evaluations": "Evaluations",
      "notes": "Notes",
      "anamnesis": "Anamnesis"
    },
    "overview": {
      "personalInfo": "Personal Information",
      "accountInfo": "Account Information",
      "fullName": "Full Name",
      "email": "Email",
      "phone": "Phone",
      "gender": "Gender",
      "birthDate": "Birth Date",
      "patientId": "Patient ID",
      "createdAt": "Created",
      "lastUpdated": "Last Updated",
      "notProvided": "Not provided"
    },
    "evaluations": {
      "title": "Patient Evaluations",
      "count": "{{count}} evaluation(s)",
      "noEvaluations": "No evaluations yet",
      "noEvaluationsDescription": "This patient doesn't have any evaluation yet. Evaluations are created from the MetaDevProfile mobile app.",
      "evaluationType": "Evaluation",
      "view": "View Details",
      "status": "Status",
      "duration": "Duration",
      "durationValue": "{{duration}}min",
      "notCompleted": "Not completed"
    },
    "notes": {
      "title": "Patient Notes",
      "noNotes": "No notes yet",
      "noNotesDescription": "Add notes about this patient to keep track of important information",
      "addFirst": "Add First Note",
      "addNote": "Add Note",
      "newNote": "New Note",
      "newNoteDescription": "Add a note about this patient",
      "placeholder": "Enter your note here...",
      "save": "Save Note",
      "cancel": "Cancel"
    },
    "anamnesis": {
      "title": "Medical Anamnesis",
      "noAnamnesis": "No anamnesis data available",
      "noAnamnesisDescription": "Medical history and anamnesis will appear here once collected",
      "medicalHistory": "Medical History",
      "medicalHistoryDescription": "Patient's medical background and relevant health information",
      "comingSoon": "Anamnesis functionality coming soon",
      "noData": "No anamnesis data available for this patient",
      "noQuestions": "No questions in this section",
      "noItems": "No items in this section",
      "noAnswer": "No answer provided"
    }
  },
  "success": {
    "createPatientSuccess": "Patient created successfully",
    "updatePatientSuccess": "Patient updated successfully"
  },
  "errors": {
    "createPatientFailed": "Failed to create patient",
    "deletePatientFailed": "Failed to delete patient",
    "loadPatientFailed": "Failed to load patient",
    "loadPatientsFailed": "Failed to load patients",
    "updatePatientFailed": "Failed to update patient",
    "loadAnamnesisFailed": "Failed to load anamnesis"
  }
}
